/*!
 * Start Bootstrap - Agency v7.0.12 (https://startbootstrap.com/theme/agency)
 * Copyright 2013-2023 Start Bootstrap
 * Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-agency/blob/master/LICENSE)
 */
//
// Scripts
//

$(document).ready(function () {
  let width = undefined;
  let height = undefined;


  handleResize();

  function handleResize() {
    width = window.innerWidth;
    height = window.innerHeight;
  }
  window.addEventListener('resize', handleResize);
});

